import { render } from "./PhoneMange.vue?vue&type=template&id=733b75a8&scoped=true"
import script from "./PhoneMange.vue?vue&type=script&lang=js"
export * from "./PhoneMange.vue?vue&type=script&lang=js"

import "./PhoneMange.vue?vue&type=style&index=0&id=733b75a8&lang=scss&scoped=true"
import "./PhoneMange.vue?vue&type=style&index=1&id=733b75a8&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733b75a8"]])

export default __exports__